// Persisted/API values. Vietnamese text is display-only and must not be saved.
export const ALBUM_TYPE_SCHOOL = "SCHOOL";
export const ALBUM_TYPE_CLASS = "CLASS";

export const ALBUM_TYPE_OPTIONS = [
  { value: ALBUM_TYPE_SCHOOL, label: "Trường" },
  { value: ALBUM_TYPE_CLASS, label: "Lớp" },
];

export function getAlbumTypeLabel(type) {
  if (type === ALBUM_TYPE_SCHOOL || type === "Trường") return "Trường";
  if (type === ALBUM_TYPE_CLASS || type === "Lớp") return "Lớp";
  return type || "";
}
